import { UserSessionService } from './UserSession/user-session.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';

/**
 * Servicio que implementa la autenticación
 */
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: UserSessionService,private router: Router) {
  }
  /**
   * Indica si se permite la navegación
   * @returns
   */
  canActivate() {

    return this.authService.checkAuthenticated().pipe(
      tap(authenticated => {
        if (!authenticated) {
          this.router.navigate(['auth/login']);
        }
      }),
    );;

  }
}
